export default __webpack_public_path__ + "static/media/1800respect.3f20f1db.png";